import moment from "moment-mini";
import TickIcon from "SVGS/TickIcon";
import CrossIcon from "SVGS/CrossIcon";
import InfoIcon from "SVGS/InfoIcon";

export const relationship = [
  { value: "", display: "Please Select" },
  { value: "18", display: "18 SELF" },
  { value: "01", display: "01 SPOUSE" },
  { value: "19", display: "19 CHILD" },
  { value: "20", display: "20 EMPLOYEE" },
  { value: "21", display: "21 UNKNOWN" },
  { value: "39", display: "39 ORGAN DONAR" },
  { value: "53", display: "53 LIFE PARTNER" },
  { value: "G8", display: "G8 OTHER RELATIONSHIP" },
];
export const statusMapping = {
  PEN_SUB: "PENDING_SUBMISSION",
  SUB: "SUBMITTED",
  DEN: "DENIED",
  ERA_REC: "ADJUDICATED",
  PAT_RES: "PATIENT_RESPONSIBILITY",
  SEC_TER: "SECONDARY_TERTIARY",
  FIN: "FINALIZED",
};
export const OTHER_ACCOUNT_PLATFORM_OPTIONS = [
  { value: 'ClearinghousePortal', label: 'Clearinghouse Portal' },
  { value: 'ERAProviderPortal', label: 'ERA Provider Portal' },
  { value: 'EFTPortal', label: 'EFT Portal' },
  { value: 'AdminPortal', label: 'Admin Portal' },
  { value: 'Other', label: 'Other' },
];
export const PRACTICE_TYPE_OPTIONS = [
  'Solo (Individual)',
  'Group Practice',
  'Hospital',
  'Clinic',
];
export const PAYER_PORTAL_OPTIONS = [
  { value: 'Navicure', label: 'Navicure' },
  { value: 'Availity', label: 'Availity' },
  { value: 'OfficeAlly', label: 'OfficeAlly' },
  { value: 'ChangeHealthcare', label: 'Change Healthcare' },
  { value: 'Waystar', label: 'Waystar' },
  { value: 'TriZetto', label: 'Tri Zetto' },
  { value: 'Optum', label: 'Optum' },
  { value: 'AbilityNetwork', label: 'Ability Network' },
  { value: 'RelayHealth', label: 'Relay Health' },
  { value: 'ZirMed', label: 'ZirMed' },
];

export const SERVICE_TYPE_OPTIONS = [
  { value: 'telehealth', label: 'Telehealth' },
  { value: 'brick & mortar', label: 'Brick & Mortar' },
  { value: 'both', label: 'Both' },
];

export const statusTooltips = {
  ALL: "View all claims in the system regardless of status.",
  PEN_SUB:
    "Claims that have not yet been submitted to payers, including new charges and held claims.",
  SUB: "Claims that have been submitted to payers and are in various stages of processing.",
  DEN: "Claims requiring attention due to denials, partial payments, or payment reversals.",
  ERA_REC: "Claims with ERA received, awaiting reconciliation and posting.",
  PAT_RES:
    "Claims with patient balance ready for billing or already sent to the patient.",
  SEC_TER: "Claims being processed by secondary or tertiary insurance payers.",
  FIN: "Claims that are completed and closed, including finalized paid, denied, partial paid, or voided claims.",
};

export const truRevSubStatusOptions = {
  PENDING_SUBMISSION: [
    { label: "New Charge", value: "NEW_CHG" },
    { label: "Held - Waiting For Provider", value: "HLD_PRO" },
    { label: "Held - Rejected By TruRev", value: "HLD_SYS" },
    { label: "Held - Other", value: "HLD_OTH" },
    { label: "Awaiting Resubmission", value: "AWT_RSB" },
  ],
  SUBMITTED: [
    { label: "Billed", value: "BLD" },
    { label: "Accepted", value: "ACPTD" },
    { label: "Rejected By Clearing House", value: "REJ_CHS" },
    { label: "Rejected By Payer", value: "REJ_PYR" },
    { label: "Resubmitted", value: "RE_SUB" },
  ],
  DENIED: [
    { label: "Denied", value: "DEN" },
    { label: "Partial Paid", value: "PRT_PD" },
    { label: "Reversal Applied", value: "REV_APD" },
  ],
  ADJUDICATED: [{ label: "ERA Received", value: "ERA_REC" }],
  PATIENT_RESPONSIBILITY: [
    { label: "Self-Pay", value: "SLF_PAY" },
    { label: "Bill To Patient", value: "BLD_PAT" },
    { label: "Sent to Patient", value: "SNT_PAT" },
  ],
  SECONDARY_TERTIARY: [
    { label: "New Charge", value: "NEW_CHG" },
    { label: "Held - Waiting For Provider", value: "HLD_PRO" },
    { label: "Held - Rejected By TruRev", value: "HLD_SYS" },
    { label: "Held - Other", value: "HLD_OTH" },
    { label: "Awaiting Resubmission", value: "AWT_RSB" },
    { label: "Billed", value: "BLD" },
    { label: "Resubmitted", value: "RE_SUB" },
    { label: "Accepted", value: "ACPTD" },
    { label: "Rejected By Clearing House", value: "REJ_CHS" },
    { label: "Rejected By Payer", value: "REJ_PYR" },
    { label: "Reversal Applied", value: "REV_APD" },
    { label: "Partial Paid", value: "PRT_PD" },
    { label: "Denied", value: "DEN" },
    { label: "ERA Received", value: "ERA_REC" },
    { label: "Self-Pay", value: "SLF_PAY" },
    { label: "Bill To Patient", value: "BLD_PAT" },
    { label: "Sent to Patient", value: "SNT_PAT" },
    { label: "Bill To Secondary", value: "BLD_SEC" },
    { label: "Bill To Tertiary", value: "BLD_TER" },
    { label: "Finalized Partial Paid", value: "FIN_PP" },
    { label: "Finalized Denied", value: "FIN_DEN" },
    { label: "Finalized Paid", value: "FIN_PD" },
    { label: "Voided", value: "VOID" },
    { label: "Not Billable", value: "NOT_BBL" },
    { label: "No Response Claim", value: "NO_RES" },
    { label: "Externally Submitted", value: "EXT_SUB" },
  ],
  FINALIZED: [
    { label: "Finalized Partial Paid", value: "FIN_PP" },
    { label: "Finalized Denied", value: "FIN_DEN" },
    { label: "Finalized Paid", value: "FIN_PD" },
    { label: "Voided", value: "VOID" },
    { label: "Not Billable", value: "NOT_BBL" },
  ],
  EXTRA: [
    { label: "No Response Claim", value: "NO_RES" },
    { label: "Externally Submitted", value: "EXT_SUB" },
  ],
};

export const FILE_EXTENSIONS = {
  PDF: "pdf",
  TXT: "txt",
  EDI_835: "835",
  PNG: "png",
  JPG: "jpg",
  JPEG: "jpeg",
  GIF: "gif",
};

export const EOB_FILE_EXTENSIONS = [
  'pdf',
  'png',
  'jpg',
  'jpeg',
  'gif',
  'xlsx',
  'xls',
  'csv'
];

export const EOB_FILE_TYPES = [
  "application/pdf",
  "image/png",
  "image/jpg",
  "image/jpeg",
  "image/gif",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
  "text/csv",
  "application/vnd.ms-excel.sheet.macroEnabled.12"
]

export const IMAGE_EXTENSIONS = [
  FILE_EXTENSIONS.PNG,
  FILE_EXTENSIONS.JPG,
  FILE_EXTENSIONS.JPEG,
  FILE_EXTENSIONS.GIF,
];

export const GENDER_OPTIONS = [
  { value: "", label: "Please Select" },
  { value: "M", label: "Male" },
  { value: "F", label: "Female" },
  { value: "O", label: "Other" },
];

export const PATIENT_SIDE_PATIENT_PAYMENT_TABS = {
  REQUEST_PAYMENTS: "request payments",
  PATIENT_PAYMENTS: "patient payments",
};
export const OTHER_REPORTS_TABS = {
  FACILITY_CHARGES_DETAILS: "facilityChargesDetails",
  INSURANCE_CHECK_LISTING: "insuranceCheckListing",
  PATIENT_WITH_ACCOUNT_CREDITS: "patientWithAccountCredits",
  PAYER_TYPE_BREAK_DOWN: "payerTypeBreakDown",
};

export const BILLING_REPORTS_TABS = {
  CPT_WISE_CHARGES_REPORT: "CptWiseChargesReport",
  CLAIM_WISE_CHARGES_REPORT: "ClaimWiseChargesReport",
  CHARGES_SUMMARY_REPORT: "ChargesSummaryReport",
  FULL_WRITE_OFF: "FullWriteOff",
  PATIENT_BALANCE_DUE_REPORT: "PatientBalanceDueReport",
  TOP_DENIALS_REPORT: "TopDenialsReport",
};

export const CHARGES_DUE_REPORTS_TABS = {
  CHARGES_DUE_INSURANCE_BY_DATE_RANGE: "chargesDueInsuranceByDateRange",
  CHARGES_DUE_PATIENT_BY_DATE_RANGE: "chargesDuePatientByDateRange",
};

export const TOTAL_REPORTS_TABS = {
  TOTAL_BY_DATE_RECEIVED: "totalByDateReceived",
  TOTAL_BY_FACILITY: "totalByFacility",
  TOTAL_BY_PROVIDER: "totalByProvider",
};

export const DAILY_REPORTS_TABS = {
  DAILY_DEPOSIT_REPORT: "dailyDepositReport",
  DAILY_MONTHLY_CHARGES_AND_DEBITS: "dailyMonthlyChargesAndDebits",
};

export const CHARGES_TOTAL_REPORTS_TABS = {
  CHARGES_TOTAL_BY_FACILITY: "chargesTotalByFacility",
  CHARGES_TOTAL_BY_PAYER: "chargesTotalByPayer",
  CHARGES_TOTAL_BY_PROVIDER: "chargesTotalByProvider",
};

export const measurementUnits = [
  {
    label: "International Unit",
    value: "F2",
  },
  {
    label: "Gram",
    value: "GR",
  },
  {
    label: "Milliliter",
    value: "ML",
  },
  {
    label: "Milligram",
    value: "ME",
  },
  {
    label: "Unit",
    value: "UN",
  },
];

/** Chargemaster add/edit modal — category dropdown values. */
export const CHARGEMASTER_CATEGORY_OPTIONS = [
  "Office Visit",
  "Procedure",
  "Membership",
  "DME",
  "Product",
  "Other",
];

/** Chargemaster add/edit modal — responsible party multi-select options. */
export const CHARGEMASTER_RESPONSIBLE_PARTY_OPTIONS = [
  { value: "Insurance", label: "Insurance" },
  { value: "Self Pay", label: "Self Pay" },
  { value: "Non Insurance", label: "Non Insurance" },
];

export const archivedDropdownOptions = [
  { value: "Generated by Mistake", label: "Generated by Mistake" },
  {
    value: "Rejected by Delivery Service",
    label: "Rejected by Delivery Service",
  },
  { value: "Requested by Provider", label: "Requested by Provider" },
  { value: "Issues with Payment Link", label: "Issues with Payment Link" },
  { value: "Other", label: "Other" },
];
export const MAX_FILE_SIZE_10MB = 10 * 1024 * 1024;

export const MAX_FILE_SIZE_30MB = 30 * 1024 * 1024;

export const MAX_FILE_SIZE_20MB = 20 * 1024 * 1024; // 20MB in bytes

export const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png"];

export const ELIGIBILITY_TYPES = [
  { value: "30", label: "Health Benefit Plan Coverage " },
  { value: "85", label: "AIDS " },
  { value: "84", label: "Abortion " },
  { value: "64", label: "Acupuncture " },
  { value: "28", label: "Adjunctive Dental Services " },
  { value: "57", label: "Air Transportation " },
  { value: "AJ", label: "Alcoholism " },
  { value: "GY", label: "Allergy " },
  { value: "79", label: "Allergy Testing " },
  { value: "15", label: "Alternate Method Dialysis " },
  { value: "13", label: "Ambulatory Service Center Facility " },
  { value: "7", label: "Anesthesia " },
  { value: "97", label: "Anesthesiologist " },
  { value: "71", label: "Audiology Exam " },
  { value: "10", label: "Blood Charges " },
  { value: "91", label: "Brand Name Prescription Drug " },
  { value: "B2", label: "Brand Name Prescription Drug - Formulary " },
  { value: "B3", label: "Brand Name Prescription Drug - Non-Formulary " },
  { value: "B1", label: "Burn Care " },
  { value: "58", label: "Cabulance " },
  { value: "87", label: "Cancer " },
  { value: "BL", label: "Cardiac " },
  { value: "BG", label: "Cardiac Rehabilitation " },
  { value: "CQ", label: "Case Management " },
  { value: "78", label: "Chemotherapy " },
  { value: "33", label: "Chiropractic " },
  { value: "34", label: "Chiropractic Office Visits " },
  { value: "16", label: "Chronic Renal Disease (CRD) Equipment " },
  { value: "BD", label: "Cognitive Therapy " },
  { value: "3", label: "Consultation " },
  { value: "C1", label: "Coronary Care " },
  { value: "BC", label: "Day Care (Psychiatric) " },
  { value: "37", label: "Dental Accident " },
  { value: "35", label: "Dental Care " },
  { value: "36", label: "Dental Crowns " },
  { value: "DG", label: "Dermatology " },
  { value: "DS", label: "Diabetic Supplies " },
  { value: "23", label: "Diagnostic Dental " },
  { value: "5", label: "Diagnostic Lab " },
  { value: "73", label: "Diagnostic Medical " },
  { value: "4", label: "Diagnostic X-Ray " },
  { value: "76", label: "Dialysis " },
  { value: "63", label: "Donor Procedures " },
  { value: "AK", label: "Drug Addiction " },
  { value: "DM", label: "Durable Medical Equipment " },
  { value: "12", label: "Durable Medical Equipment Purchase " },
  { value: "18", label: "Durable Medical Equipment Rental " },
  { value: "86", label: "Emergency Services " },
  { value: "BP", label: "Endocrine " },
  { value: "26", label: "Endodontics " },
  { value: "AR", label: "Experimental Drug Therapy " },
  { value: "BR", label: "Eye " },
  { value: "CP", label: "Eyewear and Eyewear Accessories " },
  { value: "82", label: "Family Planning " },
  { value: "CO", label: "Flu Vaccination " },
  { value: "AM", label: "Frames " },
  { value: "89", label: "Free Standing Prescription Drug " },
  { value: "BN", label: "Gastrointestinal " },
  { value: "60", label: "General Benefits " },
  { value: "92", label: "Generic Prescription Drug " },
  { value: "GF", label: "Generic Prescription Drug - Formulary " },
  { value: "GN", label: "Generic Prescription Drug - Non-Formulary " },
  { value: "BT", label: "Gynecological " },
  { value: "30", label: "Health Benefit Plan Coverage" },
  { value: "42", label: "Home Health Care " },
  { value: "43", label: "Home Health Prescriptions " },
  { value: "44", label: "Home Health Visits " },
  { value: "45", label: "Hospice " },
  { value: "47", label: "Hospital " },
  { value: "53", label: "Hospital - Ambulatory Surgical " },
  { value: "51", label: "Hospital - Emergency Accident " },
  { value: "52", label: "Hospital - Emergency Medical " },
  { value: "48", label: "Hospital - Inpatient " },
  { value: "50", label: "Hospital - Outpatient " },
  { value: "49", label: "Hospital - Room and Board " },
  { value: "80", label: "Immunizations " },
  { value: "61", label: "In-vitro Fertilization " },
  { value: "BA", label: "Independent Medical Evaluation " },
  { value: "83", label: "Infertility " },
  { value: "72", label: "Inhalation Therapy " },
  { value: "IC", label: "Intensive Care " },
  { value: "BS", label: "Invasive Procedures " },
  { value: "AO", label: "Lenses " },
  { value: "59", label: "Licensed Ambulance " },
  { value: "54", label: "Long Term Care " },
  { value: "BM", label: "Lymphatic " },
  { value: "62", label: "MRI/CAT Scan " },
  { value: "90", label: "Mail Order Prescription Drug " },
  { value: "BW", label: "Mail Order Prescription Drug: Brand Name " },
  { value: "BX", label: "Mail Order Prescription Drug: Generic " },
  { value: "55", label: "Major Medical " },
  { value: "CM", label: "Mammogram, High Risk Patient " },
  { value: "CN", label: "Mammogram, Low Risk Patient " },
  { value: "BE", label: "Massage Therapy " },
  { value: "69", label: "Maternity " },
  { value: "27", label: "Maxillofacial Prosthetics " },
  { value: "1", label: "Medical Care " },
  { value: "56", label: "Medically Related Transportation " },
  { value: "MH", label: "Mental Health " },
  { value: "CG", label: "Mental Health Facility - Inpatient " },
  { value: "CH", label: "Mental Health Facility - Outpatient " },
  { value: "CE", label: "Mental Health Provider - Inpatient " },
  { value: "CF", label: "Mental Health Provider - Outpatient " },
  { value: "NI", label: "Neonatal Intensive Care " },
  { value: "BQ", label: "Neurology " },
  { value: "65", label: "Newborn Care " },
  { value: "AQ", label: "Nonmedically Necessary Physical " },
  { value: "BI", label: "Nursery " },
  { value: "BU", label: "Obstetrical " },
  { value: "BV", label: "Obstetrical/Gynecological " },
  { value: "AD", label: "Occupational Therapy " },
  { value: "ON", label: "Oncology " },
  { value: "40", label: "Oral Surgery " },
  { value: "38", label: "Orthodontics " },
  { value: "BK", label: "Orthopedic " },
  { value: "9", label: "Other Medical " },
  { value: "77", label: "Otological Exam " },
  { value: "BB", label: "Partial Hospitalization (Psychiatric) " },
  { value: "66", label: "Pathology " },
  { value: "BH", label: "Pediatric " },
  { value: "24", label: "Periodontics " },
  { value: "88", label: "Pharmacy " },
  { value: "AE", label: "Physical Medicine " },
  { value: "PT", label: "Physical Therapy " },
  { value: "BY", label: "Physician Visit - Office: Sick " },
  { value: "BZ", label: "Physician Visit - Office: Well " },
  { value: "32", label: "Plan Waiting Period " },
  { value: "19", label: "Pneumonia Vaccine " },
  { value: "93", label: "Podiatry " },
  { value: "95", label: "Podiatry - Nursing Home Visits " },
  { value: "94", label: "Podiatry - Office Visits " },
  { value: "17", label: "Pre-Admission Testing " },
  { value: "74", label: "Private Duty Nursing " },
  { value: "CB", label: "Private Duty Nursing - Home " },
  { value: "CA", label: "Private Duty Nursing - Inpatient " },
  { value: "96", label: "Professional (Physician) " },
  { value: "A3", label: "Professional (Physician) Visit - Home " },
  { value: "99", label: "Professional (Physician) Visit - Inpatient " },
  { value: "A1", label: "Professional (Physician) Visit - Nursing Home " },
  { value: "98", label: "Professional (Physician) Visit - Office " },
  { value: "A0", label: "Professional (Physician) Visit - Outpatient " },
  {
    value: "A2",
    label: "Professional (Physician) Visit - Skilled Nursing Facility ",
  },
  { value: "75", label: "Prosthetic Device " },
  { value: "39", label: "Prosthodontics " },
  { value: "A4", label: "Psychiatric " },
  { value: "A7", label: "Psychiatric - Inpatient " },
  { value: "A8", label: "Psychiatric - Outpatient " },
  { value: "A5", label: "Psychiatric - Room and Board " },
  { value: "A6", label: "Psychotherapy " },
  { value: "PU", label: "Pulmonary " },
  { value: "BF", label: "Pulmonary Rehabilitation " },
  { value: "6", label: "Radiation Therapy " },
  { value: "A9", label: "Rehabilitation " },
  { value: "AB", label: "Rehabilitation - Inpatient " },
  { value: "AC", label: "Rehabilitation - Outpatient " },
  { value: "AA", label: "Rehabilitation - Room and Board " },
  { value: "RN", label: "Renal " },
  { value: "14", label: "Renal Supplies in the Home " },
  { value: "RT", label: "Residential Psychiatric Treatment " },
  { value: "46", label: "Respite Care " },
  { value: "25", label: "Restorative " },
  { value: "41", label: "Routine (Preventive) Dental " },
  { value: "AN", label: "Routine Exam " },
  { value: "81", label: "Routine Physical " },
  { value: "CK", label: "Screening X-ray " },
  { value: "CL", label: "Screening laboratory " },
  { value: "20", label: "Second Surgical Opinion " },
  { value: "AG", label: "Skilled Nursing Care " },
  { value: "AH", label: "Skilled Nursing Care - Room and Board " },
  { value: "BJ", label: "Skin " },
  { value: "67", label: "Smoking Cessation " },
  { value: "22", label: "Social Work " },
  { value: "AF", label: "Speech Therapy " },
  { value: "AI", label: "Substance Abuse " },
  { value: "CI", label: "Substance Abuse Facility - Inpatient " },
  { value: "CJ", label: "Substance Abuse Facility - Outpatient " },
  { value: "2", label: "Surgical " },
  { value: "8", label: "Surgical Assistance " },
  { value: "CD", label: "Surgical Benefits - Facility " },
  { value: "CC", label: "Surgical Benefits - Professional (Physician) " },
  { value: "21", label: "Third Surgical Opinion " },
  { value: "TC", label: "Transitional Care " },
  { value: "TN", label: "Transitional Nursery Care " },
  { value: "70", label: "Transplants " },
  { value: "UC", label: "Urgent Care " },
  { value: "11", label: "Used Durable Medical Equipment " },
  { value: "AL", label: "Vision (Optometry) " },
  { value: "68", label: "Well Baby Care " },
];
export const pattientSearchDropDown = [
  { text: "First name", value: "Firstname" },
  { text: "Last name", value: "Lastname" },
  { text: "Account no", value: "Accountnum" },
  { text: "Dob", value: "Dob" },
  { text: "SSN", value: "Ssn" },
  { text: "Gender", value: "Gender" },
];
export const MARITAL_STATUS_OPTIONS = [
  { value: "", label: "Please Select" },
  { value: "Single", label: "Single" },
  { value: "Married", label: "Married" },
  { value: "Divorced", label: "Divorced" },
  { value: "Widow", label: "Widow" },
  { value: "Other", label: "Other" },
];

export const IDENTITY_OPTIONS = [
  { value: "", label: "Select pronouns" },
  { value: "she/her", label: "she/her" },
  { value: "he/him", label: "he/him" },
  { value: "they/them", label: "they/them" },
];



export const providerSearchDropDown = [{ text: "CPT Code", value: "CPTCODE" }];

export const locationSearchDropDown = [
  { text: "Name", value: "NAME" },
  { text: "NPI", value: "NPI" },
  { text: "Clia Number", value: "CLIANUMBER" },
  { text: "Email", value: "EMAIL" },
  { text: "PosCode", value: "POSCODE" },
];

export const providerSearchFilter = [
  { text: "Name", value: "NAME" },
  { text: "NPI", value: "NPI" },
  { text: "SSN", value: "SSN" },
  { text: "Email", value: "EMAIL" },
  { text: "Phone Number", value: "PHONENUMBER" },
  { text: "Last Name", value: "LASTNAME" },
  { text: "First Name", value: "FIRSTNAME" },
  { text: "Taxonomy Code", value: "TAXONOMYCODE" },
];

export const ICD_SEARCH_DROP_DOWN = [
  { text: "ICD Code", value: "ICDCODE" },
  { text: "Description", value: "DESCRIPTION" },
  { text: "Short Description", value: "SHORTDESCRIPTION" },
];
export const POS_SEARCH_DROP_DOWN = [
  { text: "POS Code", value: "POSCODE" },
  { text: "Description", value: "DESCRIPTION" },
  // { text: "Short Description", value: "SHORTDESCRIPTION" },
];
export const ADJUSTMENT_CODE_SEARCH_DROP_DOWN = [
  { text: "Adjustment Code", value: "CODE" },
  { text: "Description", value: "DESCRIPTION" },
  // { text: "Short Description", value: "SHORTDESCRIPTION" },
];

export const INSURANCE_DROP_DOWN = [
  { text: "Plan Name", value: "PAYERNAME" },
  { text: "Description", value: "DESCRIPTION" },
  { text: "Plan Name_Description", value: "PAYERNAME_DESCRIPTION" },
];

export const INSURANCE_MAPPING_DROP_DOWN = [
  { text: "Insurance Plan ID", value: "INSURANCEPLANID" },
  { text: "Payer Name", value: "PAYERNAME" },
  { text: "Payer ID", value: "PAYERID" },
];

export const INSURANCE_PLAN_ADDRESS_DROP_DOWN = [
  { text: "Payer Name", value: "PAYERNAME" },
  { text: "Address", value: "ADDRESS" },
  { text: "Phone Number", value: "PHONENUMBER" },
];

export const PAYMENT_ADJUSTMENT_ACTION_CODES_DROP_DOWN = [
  { text: "Description", value: "DESCRIPTION" },
  { text: "Rejection Code", value: "REJECTIONCODE" },
  { text: "Group Code ", value: "GROUPCODE" },
  { text: "Reason Code", value: "REASONCODE" },
  { text: "Remark Code", value: "REMARKCODE" },
  { text: "Status", value: "STATUS" },
];

export const INSURANCE_PLAN_EDI_SETUP_DROP_DOWN = [
  { text: "Plan name", value: "INSURANCEPLANNAME" },
  { text: "Receiver", value: "RECEIVERID" },
  { text: "Insurance Plan", value: "INSURANCEPLANID" },
  { text: "Default Player Type", value: "DEFAULTPAYERTYPE" },
];

export const CPT_SEARCH_DROP_DOWN = [
  { text: "CPT Code", value: "CPTCODE" },
  { text: "Description", value: "DESCRIPTION" },
];

export const EMAIL_HISTORY_DROP_DOWN = [
  { text: "Sender", value: "sendFrom" },
  { text: "Recipient", value: "sendTo" },
  { text: "Subject", value: "subject" },
  { text: "First Name", value: "firstName" },
  { text: "Last Name", value: "lastName" },
  { text: "CC", value: "cc" },
  { text: "Date From", value: "fromDate" },
  { text: "Date To", value: "toDate" },
];
export const MODIFIER_SEARCH_DROP_DOWN = [
  { text: "Code", value: "CODE" },
  { text: "Description", value: "DESCRIPTION" },
];

export const RECEIVER_SEARCH_DROP_DOWN = [
  { text: "Receiver Name", value: "NAME" },
  { text: "Receiver Address", value: "ADDRESS" },
];
export const USER_SEARCH_DROP_DOWN = [
  { text: "Name", value: "NAME" },
  { text: "Email", value: "EMAIL" },
];
export const ROLES_SEARCH_DROP_DOWN = [{ text: "Role", value: "roleName" }];
export const SUBMITTER_SEARCH_DROP_DOWN = [
  { text: "Submitter Name", value: "NAME" },
];

export const titles = [
  { value: "", display: "Select" },
  { value: "MR.", display: "MR" },
  { value: "MRS.", display: "MRS" },
];
export const PMS_ENV = process.env.REACT_APP_TC_PMS + "/api";
export const TASK_ENV = process.env.REACT_APP_TC_TASK + "/api";
export const COMMON_ENV = process.env.REACT_APP_TC_COMMON + "/api";
export const dropDownApis = {
  task: {
    findTaskType: `${TASK_ENV}/DropDown/FindTaskType`,
    findTaskPriority: `${TASK_ENV}/DropDown/FindTaskPriority`,
    findTaskStatus: `${TASK_ENV}/DropDown/FindTaskStatus`,
    findTask: `${TASK_ENV}/DropDown/FindTask`,
  },
  pms: {
    findModifiers: `${PMS_ENV}/DropDown/FindModifiers`,
    findLocations: `${PMS_ENV}/DropDown/FindLocations`,
    findERAClaimStatusCodes: `${PMS_ENV}/Payment/FindERAClaimStatusCodes`,
    findReceivers: `${PMS_ENV}/DropDown/FindReceivers`,
  },
  common: {
    findTypeOfServices: `${COMMON_ENV}/TypeOfService/FindTypeOfServices`,
  },
};
// REACT_APP_TC_COMMON}/api/TypeOfService/FindTypeOfServices
export const DROP_DOWN_APIS = [
  {
    type: process.env.REACT_APP_TC_PMS,
    apis: [
      // "/DropDown/FindBillingProviders",
      // "/DropDown/FindSupervisingProviders",
      // "/DropDown/FindOrderingProviders",
      // "/DropDown/FindAttendingProviders",
      "/DropDown/FindModifiers",
      // "/DropDown/FindVisitStatusCodes",
      // "/DropDown/FindPos",
      // "/DropDown/FindRefProviders",
      "/DropDown/FindLocations",
      // "/DropDown/FindTaxonomy",
      "/Payment/FindERAClaimStatusCodes",
      "/DropDown/FindReceivers",
    ],
  },
  {
    type: process.env.REACT_APP_TC_TASK,
    apis: [
      "/DropDown/FindTaskType",
      "/DropDown/FindTaskPriority",
      "/DropDown/FindTaskStatus",
      "/DropDown/FindTask",
    ],
  },
  // "/DropDown/FindCpts",
];

export const CLAIM_STATUS_TABS = [
  {
    id: null,
    value: "ALL",
    label: "All Claims",
    countName: "totalVisits",
  },
  {
    id: null,
    value: "PEN_SUB",
    label: "Pending Submissions",
    countName: "pndingSubmission",
  },
  {
    id: null,
    value: "SUB",
    label: "Submitted",
    countName: "submitted",
  },
  {
    id: null,
    value: "DEN",
    label: "Denied",
    countName: "denied",
  },
  {
    id: null,
    value: "ERA_REC",
    label: "Adjudicated",
    countName: "adjudicated",
  },
  {
    id: null,
    value: "PAT_RES",
    label: "Patient Responsibility",
    countName: "patientResponsibility",
  },
  {
    id: null,
    value: "SEC_TER",
    label: "Secondary & Tertiary",
    countName: "secondary_Tertiary_Count",
  },
  {
    id: null,
    value: "FIN",
    label: "Finalized",
    countName: "finalized",
  },
];

export const CLAIM_STATUS_OPTIONS_LIST = [
  {
    id: null,
    value: "ACK_277_A",
    label: "Accepted",
  },
  {
    id: null,
    value: "ACK_277_D",
    label: "Rejected",
  },
  {
    id: null,
    value: "B",
    label: "Billed",
  },
  {
    id: null,
    value: "NR",
    label: "No Response",
  },
  {
    id: null,
    value: "B_P",
    label: "Billed To Primary",
  },
  {
    id: null,
    value: "B_PAT",
    label: "Billed To Patient",
  },
  {
    id: null,
    value: "B_S",
    label: "Billed To Secondary",
  },
  {
    id: null,
    value: "B_T",
    label: "Billed To Tertiary",
  },
  {
    id: null,
    value: "D",
    label: "Denied",
  },
  {
    id: null,
    value: "H",
    label: "Held",
  },
  {
    id: null,
    value: "N",
    label: "New Charge",
  },
  {
    id: null,
    value: "P",
    label: "Paid",
  },
  {
    id: null,
    value: "PP",
    label: "Partial Paid",
  },
  {
    id: null,
    value: "RA",
    label: "Reversal Applied",
  },
  {
    id: null,
    value: "RS",
    label: "Re-Submit",
  },
  {
    id: null,
    value: "V",
    label: "Voided",
  },
  {
    id: null,
    value: "W",
    label: "Write Off",
  },
];
export const PATIENT_STATEMENT_STATUS_OPTIONS_LIST = [
  {
    id: null,
    value: "ready",
    label: "Ready for Statement",
    tooltip: "All patient balances ready for statement generation.",
  },
  {
    id: null,
    value: "pending",
    label: "Ready to Send",
    tooltip: "All statements prepared to be sent to patients.",
  },
  {
    id: null,
    value: "sent",
    label: "Sent",
  },
  {
    id: null,
    value: "bad-debt",
    label: "Bad Debt",
    tooltip:
      "After three statements are sent, any unpaid patient balance is considered bad debt",
  },
  {
    id: null,
    value: "sentlog",
    label: "Statement Log",
  },
  {
    id: null,
    value: "archived",
    label: "Archived",
  },
];

export const PATIENT_STATEMENT_STATUS_VALUES = {
  READY: "ready",
  PENDING: "pending",
  SENT: "sent",
  QUEUE: "queue",
  BAD_DEBT: "bad-debt",
  SENT_LOG: "sentlog",
  ARCHIVED: "archived",
};

export const ALL_INSURANCE_COVERAGES = [
  { text: "Please Select", value: "" },
  { text: "Primary", value: "P" },
  { text: "Secondary", value: "S" },
  { text: "Tertiary", value: "T" },
  { text: "Other", value: "O" },
];
export const groupCodes = [
  { text: "Please Select", value: "" },
  { text: "CO", value: "CO" },
  { text: "OA", value: "OA" },
  { text: "PI", value: "PI" },
  { text: "PR", value: "PR" },
];
export const gendersSvg = {
  Male: "/img/icons/male.svg",
  Female: "/img/icons/female.svg",
};

// Add users dropdown
export const TEAM = [
  "Software",
  "Billing",
  "Operations",
  "Human Resource",
  "Information Technology",
  "Finance",
  "Quality Assurance",
];
export const DESIGNATION = [
  "CEO",
  "GM",
  "Manager",
  "Software Engineer",
  "Front End Developer",
  "Back End Developer",
  "Full Stack Developer",
  "Database Developer",
  "HR Manager",
  "Project Manager",
  "QA Engineer",
];
export const ROLES = [
  "Junior Billing Executive",
  "Team Lead",
  "Senior Team Lead",
  "Billing Team Lead",
  "Senior Billing Executive",
  "Assistant Manager",
  "Billing Executive",
];

export const FIRST_DATE_OF_FIRST_MONTH = moment()
  .startOf("year")
  .startOf("month")
  .format("YYYY-MM-DD");
export const TODAY_DATE = moment().format("YYYY-MM-DD");
export const PREVIOUS_WEEK_DATE = moment(TODAY_DATE)
  .subtract(1, "weeks")
  .format("YYYY-MM-DD");

export const BACKDROP_VARIANTS = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 },
};
export const POPUP_VARIANTS = {
  hidden: { x: "100%", opacity: 0 },
  visible: { x: 0, opacity: 1 },
  exit: { x: "100%", opacity: 0 },
};
export const PAYMENT_METHODS = {
  CASH: "Cash",
  CHECK: "Check",
  CREDIT_CARD: "Credit Card",
  PAYMENT_REQUEST: "Payment Request",
  VIRTUAL_CREDIT_CARD: "Virtual Credit Card",
};

export const EOB_SERVICE_HEADERS = [
  "SERV DATE",
  "UN",
  "CPT / MOD",
  "BILLED",
  "BAL. DUE",
  "ALLOWED",
  "COPAY",
  "DEDUCT",
  "COINS",
  "ADJ",
  "P. PAID",
  ""
];

export const CLAIM_STATUS_OPTIONS = [
  { value: "1", text: "(1)-Processed as Primary" },
  { value: "2", text: "(1)-Processed as Secondary" },
  { value: "3", text: "(2)-Processed as Tertiary" },
  { value: "4", text: "(3)-Denied" },
  {
    value: "19",
    text: "(19)-Processed as Primary, Forwarded to Additional Payer(s)",
  },
  {
    value: "20",
    text: "(20)-Processed as Secondary, Forwarded to Additional Payer(s)",
  },
  {
    value: "21",
    text: "(21)-Processed as Tertiary, Forwarded to Additional Payer(s)",
  },
  { value: "22", text: "(22)-Reversal of Previous Payment" },
  { value: "23", text: "(23)-Not Our Claim, Forwarded to Additional Payer(s)" },
  { value: "25", text: "(25)-Predetermination Pricing Only - No Payment" },
];

export const FILE_TYPES = {
  PDF: "application/pdf",
};

export const EOB_SPECIAL_CASES = {
  NPI: "NPI",
  "TAX ID": "Tax ID",
  EFTNUMBER: "EFT Number",
  CHECKNUMBER: "Check Number",
  ZIPCODE: "Zip Code",
  PHONENUMBER: "Phone Number",
};

export const EOB_VALIDATION_CONSTANTS = {
  MAX_MODIFIERS: 4,
  PROCEDURE_CODE_LENGTH: 5,
  MODIFIER_LENGTH: 2,
};

export const EOB_ALLOWED_GROUP_CODES = ["CO", "OA", "PI", "PR"];

export const EOB_MODIFIER_PATTERN = /^[A-Z0-9]{2}$/i;
export const EOB_ADJUSTMENT_CODE_PATTERN = /^[A-Z0-9]+$/i; // Alphanumeric only, no special characters

export const EOB_DEFAULT_VALUES = {
  PAYER_NAME: "Unknown Payer",
  CHECK_NUMBER: "N/A",
  MIME_TYPE: "application/octet-stream",
};

export const EOB_REVIEW_STATUS = {
  NONE: "none",
  PARTIAL: "partial",
  COMPLETE: "complete",
};

export const EOB_CONFIRMATION_TYPES = {
  DELETE_PAYER: "deletePayer",
  DELETE_TRANSACTION: "deleteTransaction",
  DELETE_CLAIM: "deleteClaim",
  DELETE_SERVICE: "deleteService",
  DELETE_ADJUSTMENT_CODE: "deleteAdjustmentCode",
};

export const EOB_FIELD_TYPES = {
  CHECK_NUMBER: "CHECKNUMBER",
  EFT_NUMBER: "EFTNUMBER",
  CLAIM_NUMBER: "CLAIMNUMBER",
};

export const EOB_API_RESPONSES = {
  RECORD_FOUND: "Record found",
  NO_RECORD_FOUND: "NO Record Found",
  NO_RECORD_FOUND_ALT: "No Record found",
};

export const EOB_DEBOUNCE_DELAY = 500;

export const EOB_SLIDER_CONFIG = {
  DEFAULT_POSITION: 60,
  MIN_POSITION: 20,
  MAX_POSITION: 80,
};

export const EOB_WINDOW_CONFIG = {
  SIZE_RATIO: 0.8,
  CHECK_INTERVAL: 1000,
  DRAG_TIMEOUT: 5000,
};

export const EOB_SCROLL_CONFIG = {
  MAX_ATTEMPTS: 10,
  RETRY_DELAY: 50,
  INITIAL_DELAY: 100,
};

export const PROVIDER_ADJUSTMENT_HEADERS = [
  "Reason Code",
  "Identifier",
  "Amount",
];

////////// START RBS CONSTANTS ///////////////
// Define sections and their fields
export const FIELD_SECTIONS = {
  "Patient Demographics": [
    "First Name",
    "Last Name",
    "Date of Birth",
    "Gender",
    "Marital Status",
    "SSN",
    "Email",
    "Phone Number",
    "Mobile Number",
    "Work Phone Number",
    "Address 1",
    "Address 2",
    "City",
    "State",
    "Zip Code",
  ],
  "Billing Provider": [
    "Rendering Provider",
    "Sup. Provider",
    "Ordering Provider",
    "Ref. Provider",
    "Service Location",
    "POS",
  ],
  "Diagnosis/ICD-10 Codes": ["Diagnosis/ICD-10 Code"],
  Charges: [
    "CPT/Procedure Code",
    "Charge Amount",
    "DOS From",
    "DOS To",
    "Modifier 1",
    "Modifier 2",
    "Modifier 3",
    "Modifier 4",
    "Total Amount",
    "Units",
    "POS",
  ],
  Submission: ["Insurance Plan", "POS"],
};

// Define field definitions with operators and input types
export const FIELD_DEFINITIONS = {
  "CPT/Procedure Code": {
    inputType: "text",
    operators: [
      "Does Not Exist",
      "Equals",
      "Exists",
      "In List",
      "Not Equals",
      "Not In List",
    ],
    helpText: "Enter CPT or procedure code",
    sqlMapping: {
      table: "claim_charges",
      column: "cpt_code",
    },
  },
  "Diagnosis/ICD-10 Code": {
    inputType: "text",
    operators: [
      "Does Not Exist",
      "Ends With",
      "Equals",
      "Exists",
      "In List",
      "Not Equals",
      "Not In List",
      "Starts With",
    ],
    helpText: "Format: A00.0",
    sqlMapping: {
      table: "claim_diagnoses",
      column: "icd10_code",
    },
  },
  "Rendering Provider": {
    inputType: "select",
    operators: [
      "Does Not Exist",
      "Equals",
      "Exists",
      "In List",
      "Not Equals",
      "Not In List",
    ],
    options: [
      { value: "provider1", label: "Provider 1" },
      { value: "provider2", label: "Provider 2" },
    ],
    sqlMapping: {
      table: "claims",
      column: "rendering_provider_id",
    },
  },
  "Sup. Provider": {
    inputType: "select",
    operators: [
      "Does Not Exist",
      "Equals",
      "Exists",
      "In List",
      "Not Equals",
      "Not In List",
    ],
    options: [
      { value: "provider1", label: "Provider 1" },
      { value: "provider2", label: "Provider 2" },
    ],
    sqlMapping: {
      table: "claims",
      column: "supervising_provider_id",
    },
  },
  "Ordering Provider": {
    inputType: "select",
    operators: [
      "Does Not Exist",
      "Equals",
      "Exists",
      "In List",
      "Not Equals",
      "Not In List",
    ],
    options: [
      { value: "provider1", label: "Provider 1" },
      { value: "provider2", label: "Provider 2" },
    ],
    sqlMapping: {
      table: "claims",
      column: "ordering_provider_id",
    },
  },
  "Ref. Provider": {
    inputType: "select",
    operators: [
      "Does Not Exist",
      "Equals",
      "Exists",
      "In List",
      "Not Equals",
      "Not In List",
    ],
    options: [
      { value: "provider1", label: "Provider 1" },
      { value: "provider2", label: "Provider 2" },
    ],
    sqlMapping: {
      table: "claims",
      column: "referring_provider_id",
    },
  },
  "Service Location": {
    inputType: "select",
    operators: [
      "Does Not Exist",
      "Equals",
      "Exists",
      "In List",
      "Not Equals",
      "Not In List",
    ],
    options: [
      { value: "location1", label: "Location 1" },
      { value: "location2", label: "Location 2" },
    ],
    sqlMapping: {
      table: "claims",
      column: "service_location_id",
    },
  },
  Units: {
    inputType: "number",
    operators: ["Between", "Equals", "Greater Than", "Less Than"],
    helpText: "Enter units",
    sqlMapping: {
      table: "claim_charges",
      column: "units",
    },
  },
  "Charge Amount": {
    inputType: "number",
    operators: ["Between", "Equals", "Greater Than", "Less Than"],
    helpText: "Enter charge amount",
    sqlMapping: {
      table: "claim_charges",
      column: "charge_amount",
    },
  },
  "DOS From": {
    inputType: "date",
    operators: [
      "After",
      "Before",
      "Between",
      "Equals",
      "Is Empty",
      "Is Not Empty",
    ],
    helpText: "Enter date of service from",
    sqlMapping: {
      table: "claims",
      column: "dos_from",
    },
  },
  "DOS To": {
    inputType: "date",
    operators: [
      "After",
      "Before",
      "Between",
      "Equals",
      "Is Empty",
      "Is Not Empty",
    ],
    helpText: "Enter date of service to",
    sqlMapping: {
      table: "claims",
      column: "dos_to",
    },
  },
  "Modifier 1": {
    inputType: "text",
    operators: [
      "Does Not Exist",
      "Ends With",
      "Equals",
      "Exists",
      "In List",
      "Not Equals",
      "Not In List",
      "Starts With",
    ],
    helpText: "Enter modifier 1",
    sqlMapping: {
      table: "claim_charges",
      column: "modifier_1",
    },
  },
  "Modifier 2": {
    inputType: "text",
    operators: [
      "Does Not Exist",
      "Ends With",
      "Equals",
      "Exists",
      "In List",
      "Not Equals",
      "Not In List",
      "Starts With",
    ],
    helpText: "Enter modifier 2",
    sqlMapping: {
      table: "claim_charges",
      column: "modifier_2",
    },
  },
  "Modifier 3": {
    inputType: "text",
    operators: [
      "Does Not Exist",
      "Ends With",
      "Equals",
      "Exists",
      "In List",
      "Not Equals",
      "Not In List",
      "Starts With",
    ],
    helpText: "Enter modifier 3",
    sqlMapping: {
      table: "claim_charges",
      column: "modifier_3",
    },
  },
  "Modifier 4": {
    inputType: "text",
    operators: [
      "Does Not Exist",
      "Ends With",
      "Equals",
      "Exists",
      "In List",
      "Not Equals",
      "Not In List",
      "Starts With",
    ],
    helpText: "Enter modifier 4",
    sqlMapping: {
      table: "claim_charges",
      column: "modifier_4",
    },
  },
  "Total Amount": {
    inputType: "number",
    operators: [
      "Between",
      "Equals",
      "Greater Than",
      "Is Empty",
      "Is Not Empty",
      "Less Than",
    ],
    helpText: "Enter total amount",
    sqlMapping: {
      table: "claims",
      column: "total_amount",
    },
  },
  POS: {
    inputType: "text",
    operators: ["Equals", "Is Empty", "Is Not Empty", "Not Equals"],
    helpText: "Enter place of service",
    sqlMapping: {
      table: "claims",
      column: "place_of_service",
    },
  },
  "Address 1": {
    inputType: "text",
    operators: [
      "Contains",
      "Ends With",
      "Equals",
      "Is Empty",
      "Is Not Empty",
      "Starts With",
    ],
    sqlMapping: {
      table: "patients",
      column: "address_1",
    },
  },
  "Address 2": {
    inputType: "text",
    operators: [
      "Contains",
      "Ends With",
      "Equals",
      "Is Empty",
      "Is Not Empty",
      "Starts With",
    ],
    sqlMapping: {
      table: "patients",
      column: "address_2",
    },
  },
  City: {
    inputType: "text",
    operators: [
      "Contains",
      "Ends With",
      "Equals",
      "Is Empty",
      "Is Not Empty",
      "Starts With",
    ],
    sqlMapping: {
      table: "patients",
      column: "city",
    },
  },
  "Date of Birth": {
    inputType: "date",
    operators: ["After", "Before", "Equals", "Is Empty", "Is Not Empty"],
    sqlMapping: {
      table: "patients",
      column: "date_of_birth",
    },
  },
  Email: {
    inputType: "text",
    operators: [
      "Contains",
      "Ends With",
      "Equals",
      "Is Empty",
      "Is Not Empty",
      "Is Valid Format",
      "Is Invalid Format",
      "Starts With",
    ],
    sqlMapping: {
      table: "patients",
      column: "email",
    },
  },
  "First Name": {
    inputType: "text",
    operators: [
      "Contains",
      "Ends With",
      "Equals",
      "Is Empty",
      "Is Not Empty",
      "Starts With",
    ],
    sqlMapping: {
      table: "patients",
      column: "first_name",
    },
  },
  "Last Name": {
    inputType: "text",
    operators: [
      "Contains",
      "Ends With",
      "Equals",
      "Is Empty",
      "Is Not Empty",
      "Starts With",
    ],
    sqlMapping: {
      table: "patients",
      column: "last_name",
    },
  },
  "Marital Status": {
    inputType: "select",
    operators: ["Equals", "Is Empty", "Is Not Empty"],
    options: [
      { value: "single", label: "Single" },
      { value: "married", label: "Married" },
      { value: "divorced", label: "Divorced" },
      { value: "widowed", label: "Widowed" },
    ],
    sqlMapping: {
      table: "patients",
      column: "marital_status",
    },
  },
  "Mobile Number": {
    inputType: "text",
    operators: [
      "Contains",
      "Ends With",
      "Equals",
      "Is Empty",
      "Is Not Empty",
      "Is Valid Format",
      "Is Invalid Format",
      "Starts With",
    ],
    sqlMapping: {
      table: "patients",
      column: "mobile_number",
    },
  },
  Gender: {
    inputType: "select",
    operators: ["Equals", "Is Empty", "Is Not Empty"],
    options: [
      { value: "male", label: "Male" },
      { value: "female", label: "Female" },
      { value: "other", label: "Other" },
    ],
    sqlMapping: {
      table: "patients",
      column: "gender",
    },
  },
  "Zip Code": {
    inputType: "text",
    operators: [
      "Contains",
      "Ends With",
      "Equals",
      "Is Empty",
      "Is Not Empty",
      "Is Valid Format",
      "Is Invalid Format",
      "Starts With",
    ],
    sqlMapping: {
      table: "patients",
      column: "zip_code",
    },
  },
  "Phone Number": {
    inputType: "text",
    operators: [
      "Contains",
      "Ends With",
      "Equals",
      "Is Empty",
      "Is Not Empty",
      "Is Valid Format",
      "Is Invalid Format",
      "Starts With",
    ],
    sqlMapping: {
      table: "patients",
      column: "phone_number",
    },
  },
  SSN: {
    inputType: "text",
    operators: [
      "Contains",
      "Ends With",
      "Equals",
      "Is Empty",
      "Is Not Empty",
      "Is Valid Format",
      "Is Invalid Format",
      "Starts With",
    ],
    sqlMapping: {
      table: "patients",
      column: "ssn",
    },
  },
  State: {
    inputType: "select",
    operators: ["Equals", "Is Empty", "Is Not Empty"],
    options: [
      { value: "AL", label: "Alabama" },
      { value: "AK", label: "Alaska" },
      // Add more states as needed
    ],
    sqlMapping: {
      table: "patients",
      column: "state",
    },
  },
  "Work Phone Number": {
    inputType: "text",
    operators: [
      "Contains",
      "Ends With",
      "Equals",
      "Is Empty",
      "Is Not Empty",
      "Is Valid Format",
      "Is Invalid Format",
      "Starts With",
    ],
    sqlMapping: {
      table: "patients",
      column: "work_phone_number",
    },
  },
};

// Define operator definitions
export const OPERATOR_DEFINITIONS = {
  "Does Not Exist": { requiresValue: false },
  Equals: { requiresValue: true },
  Exists: { requiresValue: false },
  "In List": { requiresValue: true, valueType: "multiple" },
  "Not Equals": { requiresValue: true },
  "Not In List": { requiresValue: true, valueType: "multiple" },
  "Ends With": { requiresValue: true },
  "Starts With": { requiresValue: true },
  Between: { requiresValue: true, valueType: "range" },
  "Greater Than": { requiresValue: true },
  "Less Than": { requiresValue: true },
  Contains: { requiresValue: true },
  "Is Empty": { requiresValue: false },
  "Is Not Empty": { requiresValue: false },
  "Is Valid Format": { requiresValue: false },
  "Is Invalid Format": { requiresValue: false },
  After: { requiresValue: true },
  Before: { requiresValue: true },
};

// Define action types
export const ACTION_TYPES = ["Approve Claim", "Deny Claim", "Send Alert"];

export const LOGIC_OPTIONS = [
  { label: "AND", value: "AND" },
  { label: "OR", value: "OR" },
];

export const TABLE_ALIASES = {
  patients: "p",
  claims: "c",
  claim_charges: "cc",
  claim_diagnoses: "cd",
  providers: "prov",
  locations: "loc",
};

export const TABLE_JOINS = {
  patients: "c.patient_id = p.id",
  claim_charges: "c.id = cc.claim_id",
  claim_diagnoses: "c.id = cd.claim_id",
  providers: "c.rendering_provider_id = prov.id",
  locations: "c.service_location_id = loc.id",
};
////////// END RBS CONSTANTS ///////////////

export const NO_OF_DAYS = [
  { value: "01", label: "1" },
  { value: "02", label: "2" },
  { value: "03", label: "3" },
  { value: "04", label: "4" },
  { value: "05", label: "5" },
  { value: "06", label: "6" },
  { value: "07", label: "7" },
  { value: "08", label: "8" },
  { value: "09", label: "9" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
  { value: "13", label: "13" },
  { value: "14", label: "14" },
  { value: "15", label: "15" },
  { value: "16", label: "16" },
  { value: "17", label: "17" },
  { value: "18", label: "18" },
  { value: "19", label: "19" },
  { value: "20", label: "20" },
  { value: "21", label: "21" },
  { value: "22", label: "22" },
  { value: "23", label: "23" },
  { value: "24", label: "24" },
  { value: "25", label: "25" },
  { value: "26", label: "26" },
  { value: "27", label: "27" },
  { value: "28", label: "28" },
  { value: "29", label: "29" },
  { value: "30", label: "30" },
  { value: "31", label: "31" },
];

export const NO_OF_MONTHS = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

export const PASSWORD_REQUIREMENTS = [
  { test: (pw) => pw.length >= 8, label: "At least 8 characters" },
  { test: (pw) => /[0-9]/.test(pw), label: "At least one number" },
  { test: (pw) => /[a-z]/.test(pw), label: "At least one lowercase letter" },
  { test: (pw) => /[A-Z]/.test(pw), label: "At least one uppercase letter" },
  {
    test: (pw) => /[^a-zA-Z0-9]/.test(pw),
    label: "At least one special character",
  },
];

export const PASSWORD_INDICATOR_ANIMATION = {
  initial: { opacity: 0, y: -5 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -5 },
  transition: { duration: 0.3 },
};

export const PASSWORD_REQUIREMENTS_LIST_ANIMATION = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.3 },
};

export const PASSWORD_REQUIREMENT_ITEM_ANIMATION = {
  initial: { opacity: 0, x: -10 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -10 },
  transition: { duration: 0.2, delay: 0.05 },
};

export const PASSWORD_PROGRESS_BAR_ANIMATION = {
  transition: { type: "spring", stiffness: 200, damping: 20 },
};

export const PAYMENT_FREQUENCIES = [
  { value: "D", label: "Daily" },
  { value: "W", label: "Weekly" },
  { value: "BW", label: "Bi-weekly" },
  { value: "M", label: "Monthly" },
  { value: "Q", label: "Quarterly" },
];

export const PAYMENT_STATUS_OPTIONS = [
  {
    value: "active",
    label: "Active",
    planDescription: "Plan is active and payments are being processed",
  },
  {
    value: "inactive",
    label: "Inactive",
    planDescription: "Plan is inactive but can be reactivated",
  },
  {
    value: "paused",
    label: "Paused",
    planDescription: "Plan is temporarily paused, payments are on hold",
  },
  {
    value: "cancelled",
    label: "Cancelled",
    planDescription: "Plan has been cancelled and cannot be reactivated",
  },
  {
    value: "completed",
    label: "Completed",
    planDescription: "All payments have been successfully completed",
  },
];
export const GRACE_PERIOD_OPTIONS = [
  { value: 0, label: "No grace period" },
  { value: 1, label: "1 day" },
  { value: 3, label: "3 days" },
  { value: 5, label: "5 days" },
  { value: 7, label: "7 days" },
  { value: 14, label: "14 days" },
];
export const SOCKET_STATUS = {
  PENDING: "Pending",
  INPOROCESS: "In Process",
  POROCESSED: "Processed",
  INREVIEW: "In Review",
  UPLOADED: "Uploaded",
  POSTED: "Posted",
  FAILED: "Failed",
};
export const EOB_PROCESSING_STATUS = {
  PENDING: "Pending",
  MERGING: "Merging",
  PARSING: "Parsing",
  SPLITTING: "Splitting",
  EXTRACTING: "Extracting",
  COMPLETED: "Completed",
  FAILED: "Failed",
};
export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const PATIENT_STATUS = [
  { value: "all", label: "All" },
  { value: "archived", label: "Archived" },
  { value: "active", label: "Active" },
];
export const PRIORITY_COLORS = {
  Urgent: "#B13A41",
  High: "#CF940A",
  Normal: "#4466FF",
  Low: "#87909E",
};

export const PAYMENT_LINE_ITEM_TYPES = [
  { value: "", label: "Select Type", showInDropdown: true },
  { value: "OUTBAL", label: "Outstanding Balance", showInDropdown: true },
  { value: "COP", label: "Copay", showInDropdown: true },
  { value: "DED", label: "Deductible", showInDropdown: true },
  { value: "COINS", label: "Coinsurance", showInDropdown: true },
  { value: "OTHER", label: "Other", showInDropdown: true },
  { value: "CCFEE", label: "Credit Card Fees", showInDropdown: false },
  { value: "DISCNT", label: "Discount", showInDropdown: false },
  { value: "BALPP", label: "Balance Payment Plan", showInDropdown: false },
  { value: "SUBPP", label: "Subscription Payment Plan", showInDropdown: false },
  {
    value: "PREPP",
    label: "Pre-Treatment Payment Plan",
    showInDropdown: false,
  },
  { value: "PIP", label: "Invoice", showInDropdown: false },
];
export const STANDARD_ZOOM_LEVELS = [
  100, 110, 125, 150, 180, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1100,
  1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000,
];

// EOB Parser Tooltip Style Configuration
export const EOB_TOOLTIP_STYLE = { zIndex: 99999, maxWidth: 300 };

// EOB Parser Status Indicator Configurations
export const EOB_STATUS_CONFIGS = {
  checking: {
    className: "bg-blue-50 border-blue-200 text-blue-700",
    icon: (
      <div className="w-4 h-4 mr-2 border-b-2 border-blue-600 rounded-full animate-spin"></div>
    ),
    text: "Checking...",
  },
  available: {
    className: "bg-green-50 border-green-200 text-green-700",
    icon: <TickIcon size={16} color="#10B981" className="mr-2" />,
    text: "Available",
  },
  exists: {
    className: "bg-red-50 border-red-200 text-red-700",
    icon: <CrossIcon size={16} color="#EF4444" className="mr-2" />,
    text: "Already Exists",
  },
  error: {
    className: "bg-orange-50 border-orange-200 text-orange-700",
    icon: <InfoIcon size={16} color="#F59E0B" className="mr-2" />,
    text: "Check Failed",
  },
};

export const PATIENT_STATEMENT_READY_FOR_STATEMENT_ACTIVE_TABS = [
  {
    id: 1,
    value: "pr1_pr2_pr3",
    label: "Cost Share",
    tooltip:
      "The portion of the claim the patient must pay, including deductible (PR-1), coinsurance (PR-2), copay (PR-3).",
  },
  {
    id: 2,
    value: "other_pr",
    label: "Other PR",
    tooltip:
      "Patient responsibility that is not copay, deductible, or coinsurance — such as non-covered services, exclusions, or plan limits.",
  },
];

export const PENDING_VALIDATION_TABS = [
  { value: "Electronic", label: "Electronic" },
  { value: "Paper", label: "Paper" },
  { value: "All", label: "All" },
];

export const STRIPE_READER_DEVICE_TYPES = [
  {
    value: "stripe_s700",
    label: "Stripe Reader S700 (Smart reader)"
  },
  {
    value: "stripe_s710",
    label: "Stripe Reader S710 (Cellular-capable smart reader)"
  },
  {
    value: "bbpos_wisepos_e",
    label: "BBPOS WisePOS E (Smart reader)"
  },
  {
    value: "stripe_m2",
    label: "Stripe Reader M2 (Mobile reader)"
  },
  {
    value: "bbpos_wisepad3",
    label: "BBPOS WisePad 3 (Mobile reader)"
  },
  {
    value: "bbpos_chipper2x",
    label: "BBPOS Chipper 2X BT (Mobile reader)"
  },
  {
    value: "mobile_phone_reader",
    label: "Tap to Pay on iPhone or Android"
  },
  {
    value: "verifone_v660p",
    label: "Verifone V660p (Handheld/Countertop)"
  },
  {
    value: "verifone_p630",
    label: "Verifone P630 (Countertop)"
  },
  {
    value: "verifone_m425",
    label: "Verifone M425 (Countertop)"
  },
  {
    value: "verifone_ux700",
    label: "Verifone UX700 (Self-service kiosk)"
  },
  {
    value: "simulated_stripe_s700",
    label: "Simulated Stripe S700 reader"
  },
  {
    value: "simulated_wisepos_e",
    label: "Simulated BBPOS WisePOS E reader"
  }
];

export const INTEGRATION_STATUS = {
  AVAILABLE: "available",
  COMING_SOON: "coming-soon",
  CONFIGURED: "configured",
};

export const ALERT_CLAIMS = [
  { screenName: "New Charges", value: 0, claimStatusCode: "" },
  { screenName: "Rejected by TruRev", value: 0, claimStatusCode: "" },
  { screenName: "No Response Claims", value: 0, claimStatusCode: "" },
  { screenName: "Rejected by Payer", value: 0, claimStatusCode: "" },
  { screenName: "ERA Received", value: 0, claimStatusCode: "" },
  { screenName: "Denied", value: 0, claimStatusCode: "" },
  { screenName: "Bill To Patient", value: 0, claimStatusCode: "" },
  { screenName: "Externally Submitted", value: 0, claimStatusCode: "" },
];

export const INITIAL_TAG_STATE = {
  patientTag: [
    { screen: "Ready For QA", colorCode: "#c0d93f", value: 0 },
    { screen: "Closed", colorCode: "#000000", value: 0 },
    { screen: "Ready For Live", colorCode: "#03a032", value: 0 },
    { screen: "Taskeen", colorCode: "#ff7575", value: 0 },
    { screen: "Discussion Required", colorCode: "#ec557b", value: 0 },
    { screen: "On Hold", colorCode: "#dd7027", value: 0 },
    { screen: "Dilawar Ali", colorCode: "#000000", value: 0 },
    { screen: "DIL ALI", colorCode: "#122629", value: 0 },
    { screen: "Don't Bill", colorCode: "#aa9cc9", value: 0 },
    { screen: "ALIABC", colorCode: "#000000", value: 0 },
  ],
  paymentTag: [
    { screen: "Closed", colorCode: "#000000", value: 0 },
    { screen: "Ready For QA", colorCode: "#c0d93f", value: 0 },
    { screen: "Ready For Live", colorCode: "#03a032", value: 0 },
    { screen: "Discussion Required", colorCode: "#ec557b", value: 0 },
    { screen: "Taskeen", colorCode: "#ff7575", value: 0 },
    { screen: "On Hold", colorCode: "#dd7027", value: 0 },
    { screen: "Don't Bill", colorCode: "#aa9cc9", value: 0 },
    { screen: "R&D Started", colorCode: "#14cfd2", value: 0 },
    {
      screen: "Waiting for Clearing House Response",
      colorCode: "#e69b19",
      value: 0,
    },
    { screen: "Testing team ", colorCode: "#000000", value: 0 },
  ],
};
export const INITIAL_TASK_STATE = {
  allTask: [
    {
      screen: "Open",
      value: 0,
    },
    { screen: "In-Progress", value: 0 },
    { screen: "Complete", value: 0 },
    { screen: "Held", value: 0 },
  ],
  myTask: [
    { screen: "Open", value: 0 },
    { screen: "In-Progress", value: 0 },
    { screen: "Complete", value: 0 },
    { screen: "Held", value: 0 },
  ],
};

export const DAYS_OF_WEEK = [
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
  { value: 0, label: "Sunday" },
];
export const DELAY_REASON_OPTIONS = [
  { value: "1", label: "Proof of Eligibility Unknown or Unavailable" },
  { value: "2", label: "Litigation" },
  { value: "3", label: "Authorization Delays" },
  { value: "4", label: "Delay in Certifying Provider" },
  { value: "5", label: "Delay in Supplying Billing Forms" },
  { value: "6", label: "Delay in Delivery of Custom-made Appliances" },
  { value: "7", label: "Third Party Processing Delay" },
  { value: "8", label: "Delay in Eligibility Determination" },
  { value: "9", label: "Original Claim Rejected or Denied Unrelated to Filing Limit" },
  { value: "10", label: "Administration Delay in Prior Approval" },
  { value: "15", label: "Natural Disaster" },
  { value: "11", label: "Other" }
];



export const US_STATE_OPTIONS = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
  { label: "District of Columbia", value: "DC" },
  { label: "Puerto Rico", value: "PR" },
  { label: "Armed Forces Pacific", value: "AP" },
];

/** State codes only (e.g. for Geography selection). Use US_STATE_OPTIONS when you need label + value. */
export const US_STATES = US_STATE_OPTIONS.map((o) => o.value);

export const LINE_OF_BUSINESS_OPTIONS = [
  'Commercial',
  'Medicare Advantage',
  'Managed Medicaid',
  'Exchange/Marketplace/ACA',
  'Traditional Medicaid',
  'Traditional Medicare',
  'Government',
];

const COMMON_PROVIDER_LICENSE_TYPE_OPTIONS = [
  {
    optionGroup: 'Doctors', options: [
      { label: 'DO - Doctor of Osteopathic Medicine', value: 'DO' },
      { label: 'DPM - Doctor of Podiatric Medicine', value: 'DPM' },
      { label: 'MD - Medical Doctor', value: 'MD' },
      { label: 'OD - Optometrist', value: 'OD' },
      { label: 'SLPD - Doctor of Speech - Language Pathology', value: 'SLPD' },
      { label: 'DPT - Doctor of Physical Therapy', value: 'DPT' },
      { label: 'OTD - Doctor of Occupational Therapy', value: 'OTD' },
    ]
  },
  { optionGroup: 'Nursing', options: [{ label: 'APN - Advanced Practice Nurse', value: 'APN' }, { label: 'CNM - Certified Nurse Midwife', value: 'CNM' }, { label: 'CNS - Clinical Nurse Specialist', value: 'CNS' }, { label: 'CRNA - Certified Registered Nurse Anesthetist', value: 'CRNA' }, { label: 'LPN - Licensed Practical Nurse', value: 'LPN' }, { label: 'LVN - Licensed Vocational Nurse', value: 'LVN' }, { label: 'NP - Nurse Practitioner', value: 'NP' }, { label: 'PMHNP - Psychiatric Mental Health Nurse Practitioner', value: 'PMHNP' }, { label: 'RN - Registered Nurse', value: 'RN' }, { label: 'RNFA - Registered Nurse First Assistant', value: 'RNFA' }] },
  { optionGroup: 'Mid-Level', options: [{ label: 'PA - Physician Assistant', value: 'PA' }] },
  {
    optionGroup: 'Behavioral Health', options: [
      { label: 'ACMHC - Associate Clinical Mental Health Counselor', value: 'ACMHC' },
      { label: 'ACSW - Associate Clinical Social Worker', value: 'ACSW' },
      { label: 'ALC - Associate Licensed Counselor', value: 'ALC' },
      { label: 'APC - Associate Professional Counselor', value: 'APC' },
      { label: 'APCC - Associate Professional Clinical Counselor', value: 'APCC' },
      { label: 'APSW - Advanced Practice Social Worker', value: 'APSW' },
      { label: 'BCaBA - Board Certified Assistant Behavior Analyst', value: 'BCaBA' },
      { label: 'BCBA - Board Certified Behavior Analyst', value: 'BCBA' },
      { label: 'BCBA - D - Board Certified Behavior Analyst - Doctoral', value: 'BCBA - D' },
      { label: 'BHA - Behavioral Health Assessor', value: 'BHA' },
      { label: 'BHARI - Behavioral Health Assessor Registered Intern', value: 'BHARI' },
      { label: 'BSC - Behavioral Specialist Consultant', value: 'BSC' },
      { label: 'CAADC - Certified Advanced Addiction & Drug Counselor', value: 'CAADC' },
      { label: 'CADAC - Certified Alcohol and Drug Addiction Consultant', value: 'CADAC' },
      { label: 'CAS - Certified Addiction Specialist', value: 'CAS' },
      { label: 'CAT - Certified Addiction Therapist', value: 'CAT' },
      { label: 'CCS - Certified Clinical Supervisor', value: 'CCS' },
      { label: 'CDCA - Chemical Dependency Counselor Assistant', value: 'CDCA' },
      { label: 'CISW - Certified Independent Social Worker', value: 'CISW' },
      { label: 'CMHC - Clinical Mental Health Counselor', value: 'CMHC' },
      { label: 'CMSW - Certified Master Social Worker', value: 'CMSW' },
      { label: 'CSW - Certified Social Worker', value: 'CSW' },
      { label: 'CSW - PIP - Certified Social Worker Private Independent Practice', value: 'CSW - PIP' }, { label: 'ISW - Independent Social Worker', value: 'ISW' }, { label: 'LAC - Licensed Associate Counselor', value: 'LAC' }, { label: 'LACMH - Licensed Associate Counselor of Mental Health', value: 'LACMH' },
      { label: 'LADC - Licensed Alcohol and Drug Counselor', value: 'LADC' },
      { label: 'LAPC - Associate Licensed Professional Counselor', value: 'LAPC' },
      { label: 'LASW - Licensed Advanced Social Worker', value: 'LASW' },
      { label: 'LCADC - Licensed Clinical Alcohol and Drug Counselor', value: 'LCADC' },
      { label: 'LCAS - Licensed Clinical Addiction Specialist', value: 'LCAS' },
      { label: 'LCAT - Licensed Creative Arts Therapist', value: 'LCAT' },
      { label: 'LCMHC - Licensed Clinical Mental Health Counselor', value: 'LCMHC' },
      { label: 'LCMHC - S - Licensed Clinical Mental Health Counselor - Supervisor', value: 'LCMHC - S' },
      { label: 'LCMHCA - Licensed Clinical Mental Health Counselor Associate', value: 'LCMHCA' },
      { label: 'LCPC - Licensed Clinical Professional Counselor', value: 'LCPC' },
      { label: 'LCSW - Licensed Clinical Social Worker', value: 'LCSW' },
      { label: 'LCSW - C - Licensed Certified Social Worker - Clinical', value: 'LCSW - C' },
      { label: 'LCSWA - Licensed Clinical Social Worker Associate', value: 'LCSWA' },
      { label: 'LGPC - Licensed Graduate Professional Counselor', value: 'LGPC' },
      { label: 'LGSW - Licensed Graduate Social Worker', value: 'LGSW' },
      { label: 'LICSW - Licensed Independent Clinical Social Worker', value: 'LICSW' },
      { label: 'LIMHP - Licensed Independent Mental Health Practitioner', value: 'LIMHP' },
      { label: 'LIMHP - CMSW - Licensed Independent Mental Health Practitioner - Certified Master Social Worker', value: 'LIMHP - CMSW' },
      { label: 'LIMHP - CPC - Licensed Mental Health Practitioner', value: 'LIMHP - CPC' },
      { label: 'LIMHP - CSW - Licensed Independent Mental Health Practitioner - Certified Social Worker', value: 'LIMHP - CSW' },
      { label: 'LISW - Licensed Independent Social Worker', value: 'LISW' },
      { label: 'LISW - CP - Licensed Independent Social Worker - Clinical Practice', value: 'LISW - CP' },
      { label: 'LLC - Limited Licensed Counselor', value: 'LLC' }, { label: 'LLMSW - Limited Licensed Masters Social Worker', value: 'LLMSW' },
      { label: 'LMFT - Licensed Marriage and Family Therapist', value: 'LMFT' },
      { label: 'LMFT - S - Licensed Marriage and Family Therapist - Supervisor', value: 'LMFT - S' },
      { label: 'LMFTA - Licensed Marriage and Family Therapist Associate', value: 'LMFTA' },
      { label: 'LMHC - Licensed Mental Health Counselor', value: 'LMHC' },
      { label: 'LMHCA - Licensed Mental Health Counselor Associate', value: 'LMHCA' },
      { label: 'LMSW - Licensed Master Social Worker', value: 'LMSW' },
      { label: 'LPC - Licensed Professional Counselor', value: 'LPC' }, { label: 'LPC - C - Licensed Professional Counselor - Candidate', value: 'LPC - C' }, { label: 'LPC - MH - Licensed Professional Counselor - Mental Health', value: 'LPC - MH' }, { label: 'LPC / MHSP - Licensed Professional Counselor - Mental Health Service Provider', value: 'LPC / MHSP' }, { label: 'LPCA - Licensed Professional Counselor Associate', value: 'LPCA' }, { label: 'LPCC - Licensed Professional Clinical Counselor', value: 'LPCC' }, { label: 'LPCI - Licensed Professional Counselor Intern', value: 'LPCI' }, { label: 'LPCMH - Licensed Professional Counselor of Mental Health', value: 'LPCMH' }, { label: 'LSCSW - Licensed Specialist Clinical Social Worker', value: 'LSCSW' }, { label: 'LSW - Licensed Social Worker', value: 'LSW' }, { label: 'LSW - C - Licensed Social Work Candidate', value: 'LSW - C' }, { label: 'LSWA - Licensed Social Worker Associate', value: 'LSWA' }, { label: 'MFTA - Marriage and Family Therapist Associate', value: 'MFTA' }, { label: 'MHCA - Mental Health Counselor Associate', value: 'MHCA' }, { label: 'MHT - Mental Health Technician', value: 'MHT' }, { label: 'MLADC - Master Licensed Alcohol and Drug Counselor', value: 'MLADC' }, { label: 'MLSW - Masters Level Social Worker', value: 'MLSW' }, { label: 'MT - BC - Music Therapy Board Certification', value: 'MT' }, { label: 'OT - Occupational Therapist', value: 'OT' }, { label: 'OTA - Occupational Therapy Assistant', value: 'OTA' }, { label: 'PhD - Psychologist', value: 'PhD' }, { label: 'PsyD - Doctor of Psychology', value: 'PsyD' }, { label: 'RBT - Registered Behavior Technician', value: 'RBT' }, { label: 'RCSWI - Registered Clinical Social Worker Intern', value: 'RCSWI' }, { label: 'RESCOUN - Resident in Counseling', value: 'RESCOUN' }, { label: 'RESMFT - Resident in Marriage and Family Therapy', value: 'RESMFT' }, { label: 'RHMCI - Registered Mental Health Counselor Intern', value: 'RHMCI' }, { label: 'RMFTI - Registered Marriage and Family Therapy Intern', value: 'RMFTI' }, { label: 'RxP - Prescribing Psychologist', value: 'RxP' }, { label: 'SCSW - Supervisee in Clinical Social Work', value: 'SCSW' }, { label: 'SLP - Speech Language Pathologist', value: 'SLP' }]
  },
  { optionGroup: 'Dentistry', options: [{ label: 'DA - Dental Assistant', value: 'DA' }, { label: 'DDS - Doctor of Dental Surgery', value: 'DDS' }, { label: 'DEH - Dental Hygienist', value: 'DEH' }, { label: 'DMD - Doctor of Dental Medicine', value: 'DMD' }, { label: 'OMS - Oral Surgeon', value: 'OMS' }, { label: 'ORTH - Orthodontist', value: 'ORTH' }] },
  { optionGroup: 'Other Providers', options: [{ label: 'AA - Anesthesiologist Assistant', value: 'AA' }, { label: 'ACU - Acupuncturist', value: 'ACU' }, { label: 'ATC - Athletic Trainer Certified', value: 'ATC' }, { label: 'Athletic Trainer', value: 'Athletic Trainer' }, { label: 'AuD - Audiologist', value: 'AuD' }, { label: 'CCP - Perfusionist', value: 'CCP' }, { label: 'CFA - Surgical Technologist / Assistant', value: 'CFA' }, { label: 'CMT - Certified Medication Technician', value: 'CMT' }, { label: 'COTA - Certified Occupational Therapy Assistant', value: 'COTA' }, { label: 'Counselor', value: 'Counselor' }, { label: 'CP - Certified Prosthetist', value: 'CP' }, { label: 'CP - A - Clinical Pharmacist, Advanced', value: 'CP - A' }, { label: 'CST - Surgical Technologist / Assistant', value: 'CST' }, { label: 'DC - Chiropractor', value: 'DC' }, { label: 'DT - Dietician', value: 'DT' }, { label: 'EMR - Emergency Medical Responder', value: 'EMR' }, { label: 'EMT - Emergency Medical Technician', value: 'EMT' }, { label: 'EMT - A - Emergency Medical Technician Advanced', value: 'EMT - A' }, { label: 'Fitness Professional', value: 'Fitness Professional' }, { label: 'GC - Genetic Counselor', value: 'GC' }, { label: 'LAc - Licensed Acupuncturist', value: 'LAc' }, { label: 'LCDC - Licensed Chemical Dependency Counselor', value: 'LCDC' }, { label: 'LIAC - Licensed Independent Addiction Counselor', value: 'LIAC' }, { label: 'LISAC - Licensed Independent Substance Abuse Counselor', value: 'LISAC' }, { label: 'LMAC - Licensed Master Addiction Counselor', value: 'LMAC' }, { label: 'LMPC - Licensed Massage Practitioner Certified', value: 'LMPC' }, { label: 'LMT - Licensed Massage Therapist', value: 'LMT' }, { label: 'LN - Nutritionist', value: 'LN' }, { label: 'MA - Medical Assistant', value: 'MA' }, { label: 'MLT - Medical Laboratory Technician', value: 'MLT' }, { label: 'MOT - Master of Occupational Therapy', value: 'MOT' }, { label: 'MPT - Master of Physical Therapy', value: 'MPT' }, { label: 'MT - Massage Therapist', value: 'MT' }, { label: 'ND - Naturopathic Doctor', value: 'ND' }, { label: 'NMT - Nuclear Medicine Technologist', value: 'NMT' }, { label: 'OPA - Osteopathic Physician Assistant', value: 'OPA' }, { label: 'OPF - Orthotics / Prosthetics Fitter', value: 'OPF' }, { label: 'OPT - Optician', value: 'OPT' }, { label: 'Opthamologist', value: 'Opthamologist' }, { label: 'ORT - Orthotist', value: 'ORT' }] },
  {
    optionGroup: 'Other - Allied Health', options: [
      { label: 'OTR / L - Occupational Therapist Registered Licensed', value: 'OTR / L' },
      { label: 'PAR - Paramedic', value: 'PAR' },
      { label: 'PBT - Phlebotomist', value: 'PBT' },
      { label: 'Pharmacy Assistant', value: 'Pharmacy Assistant' },
      { label: 'PhT - Pharmacy Technician', value: 'PhT' },
      { label: 'PI - Pharmacy Intern', value: 'PI' },
      { label: 'Podiatric Assistant', value: 'Podiatric Assistant' },
      { label: 'PT - Physical Therapist', value: 'PT' },
      { label: 'PTA - Physical Therapy Assistant', value: 'PTA' },
      { label: 'Radiology Technician', value: 'Radiology Technician' },
      { label: 'RD - Registered Dietitian', value: 'RD' },
      { label: 'RDN - Registered Dietitian Nutritionist', value: 'RDN' },
      { label: 'RPh - Pharmacist', value: 'RPh' },
      { label: 'RT - Respiratory Therapist', value: 'RT' },
      { label: 'SA - Surgical Technologist / Assistant', value: 'SA' },
      { label: 'SAC - IT - Substance Abuse Counselor in Training', value: 'SAC' },
      { label: 'SLP - CF - Speech Language Pathologist - Clinical Fellow', value: 'SLP - CF' },
      { label: 'SLPA - Speech - Language Pathology Assistant', value: 'SLPA' },
    ]
  }
]
export const PROVIDER_PROFESSION_OPTIONS = [
  ...COMMON_PROVIDER_LICENSE_TYPE_OPTIONS,
];

export const PROVIDER_LICENSE_TYPE_OPTIONS = [
  ...COMMON_PROVIDER_LICENSE_TYPE_OPTIONS,
  {
    optionGroup: 'Rx Licenses', options: [
      { label: 'DEA - Drug Enforcement Administration Registration', value: 'DEA' },
      { label: 'CSR - Controlled Substance Registration', value: 'CSR' },
      { label: 'Rx Auth for NP - Prescriptive Authority License for an NP', value: 'RxNP' },
      { label: 'Rx Auth for CNM - Prescriptive Authority License for a CNM', value: 'RxCNM' },
      { label: 'Rx Auth for PMHNP - Prescriptive Authority License for a PMHNP', value: 'RxPMHNP' },
      { label: 'Auton Reg for NP - Autonomous Registration License for an NP', value: 'AutonNP' },
      { label: 'Auton Reg for CNM - Autonomous Registration License for a CNM', value: 'AutonCNM' },
      { label: 'Auton Reg for PMHNP - Autonomous Registration License for a PMHNP', value: 'AutonPMHNP' },
    ]
  }
];
export const ColType = {
  Text: 'text',
  Id: 'id',
  Date: 'date',
  DateTime: 'datetime',
  Money: 'money',
  Number: 'number',
  Pct: 'pct',
  Status: 'status',
  Bool: 'bool',
}